<template>
	<div class="mainFooter" :class="{ overlapping: large }">
		<div class="mainFooter-legal" :class="{ large }">
			<div class="mainFooter-legal-side mainFooter-legal-side--left">
				<div class="mainFooter-logo">
					<img src="/images/logos/logo-patch-white-border.png" alt="">
				</div>
				<strong>
					&copy; Mijn&nbsp;Mooie&nbsp;Straat&nbsp;{{ (new Date()).getFullYear() }}
					<i class="version">{{ appVersion }}</i>
				</strong>
			</div>
			<div class="mainFooter-legal-side mainFooter-legal-side--right">
				<a href="https://mijnmooiestraat.be/algemene-voorwaarden.php" class="footerLink footerLink--disclaimer mainFooter-link">disclaimer</a>
			</div>
		</div>
	</div>
</template>

<script src="./Footer.js"></script>
